var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3444 20.4574C13.9729 21.3669 13.785 20.609 13.785 38.7384C13.785 40.3607 15.636 41.2893 16.9405 40.3189C22.5149 36.116 23.6287 35.752 23.6287 33.7861C23.6287 20.5749 23.4747 21.3179 24.0693 20.4574L33.1216 8.13566H4.29221L13.3444 20.4574ZM36.541 1.71855C36.2176 1.09902 35.5832 0.713867 34.8849 0.713867H2.52893C1.02072 0.713867 0.133301 2.4152 0.998457 3.65137C1.00557 3.66324 0.900254 3.5191 2.57033 5.79199H34.8434C36.2666 3.85504 37.2179 3.01816 36.541 1.71855Z",
    fill: "url(#paint0_linear_11686_1384)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_1384",
    x1: 5.1947,
    y1: 1.49804,
    x2: 40.8034,
    y2: 26.5565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a9ec43363e35ddedc3d614345c6da55b.svg";
export { ForwardRef as ReactComponent };